import type React from "react";
import { ReactComponent as Svg } from "./assets/tick.svg";
import * as styles from "./Icon.module.scss";

type TickProps = React.SVGProps<SVGSVGElement>;

export const Tick = ({ className, ...props }: TickProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
